import request from '@/config/axios'

export interface FacilityRelationVO {
  id: string | number
  targetType: string // HOTEL / ROOM_TYPE / ROOM
  targetId: string | number
  facilityId: string | number
  facilityName?: string
  isFree: number // 0 收费/1 免费
  createTime?: string
}

export interface BatchSaveDTO {
  targetType: string
  targetId: string | number
  relations: {
    facilityId: string | number
    isFree: number
  }[]
}

// 根据目标查询关联设施
export const listByTarget = (targetType: string, targetId: string | number) => {
  return request.get({ url: '/hotel/facility-relation/list-by-target', params: { targetType, targetId } })
}

// 批量保存关联
export const batchSave = (data: BatchSaveDTO) => {
  return request.post({ url: '/hotel/facility-relation/batch-save', data })
}

// 删除关联
export const deleteRelation = (id: string | number) => {
  return request.delete({ url: '/hotel/facility-relation/delete?id=' + id })
}
